import React from "react";
import { ITextInput } from "types/gaiaComponents/input";
import { CircleX } from "lucide-react";
import { ICON_SIZE, KEY } from "./constants";

export const TextInput = React.forwardRef<HTMLInputElement, ITextInput>((props, ref) => {
    return (
        <div className={`ga-input${props.invalid ? ' ga-input--invalid' : ''}${props.success ? ' ga-input--success' : ''}${props.className ? ` ${props.className}` : ''}`}>
            {props.leftIcon}
            <input
                className="ga-input__field"
                type={props.type || "text"}
                id={props.id}
                data-testid={props.id}
                ref={ref}
                autoFocus={props.autoFocus}
                {...(props.value !== undefined ? { value: props.value } : {})}
                defaultValue={props.defaultValue}
                placeholder={props.placeholder}
                disabled={props.disabled}
                readOnly={props.readOnly}
                maxLength={props.maxLength}
                tabIndex={props.tabIndex}
                data-cy={props.dataCy}
                onChange={props.onChange}
                onBlur={props.onBlur}
                onFocus={props.onFocus}
                onKeyDown={props.onKeyDown}
            />
            {props.value && props.onClear &&
                    <span role="button"
                         tabIndex={0}
                         aria-label={props.clearAriaLabel || "Clear input"}
                         onClick={props.onClear}
                         onKeyDown={e => {
                             if (e.key === KEY.ENTER || e.key === KEY.SPACE) {
                                 e.preventDefault();
                                 props.onClear();
                             }
                         }}>
                        <CircleX size={ICON_SIZE.SMALL}/>
                    </span>
            }
            {props.rightIcon}
        </div>
    );
});

TextInput.displayName = 'TextInput';
